// src/reportWebVitals.js
import { analytics } from './core/config/firebase';
import { logEvent } from 'firebase/analytics';

/**
 * Reports Web Vitals to Firebase Analytics
 * Tracks: CLS, FID, FCP, LCP, TTFB
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

/**
 * Sends Web Vitals metrics to Firebase Analytics
 * @param {Object} metric - Web Vitals metric object
 */
export const sendToFirebaseAnalytics = (metric) => {
  if (!analytics) {
    console.warn('Analytics not initialized, skipping web vitals reporting');
    return;
  }

  try {
    const { name, value, id, delta } = metric;

    // Log the metric to Firebase Analytics
    logEvent(analytics, 'web_vitals', {
      event_category: 'Web Vitals',
      event_label: id,
      metric_name: name,
      metric_value: Math.round(name === 'CLS' ? value * 1000 : value),
      metric_delta: Math.round(name === 'CLS' ? delta * 1000 : delta),
      metric_id: id
    });

    if (process.env.NODE_ENV === 'development') {
      console.log(`📊 Web Vitals - ${name}:`, {
        value: Math.round(name === 'CLS' ? value * 1000 : value),
        rating: metric.rating
      });
    }
  } catch (error) {
    console.error('Error sending web vitals to Firebase:', error);
  }
};

export default reportWebVitals;
